import { Col, DesignTokens, Row } from "melco-ui";
import { useEffect, useState } from "react";
import { Search } from "../search/Search";
import { AllProductsGeneralSelect } from "../common/AllProductsGeneralSelect";
import { isEmpty } from "lodash-es";
import { CategoriesSelect } from "../common/CategoriesSelect";
import { MachinesSelect } from "../machines/MachinesSelect";
import styled from "styled-components";

export type ManageThreadsListFiltersType = {
    machines?: string | string[];
    searchText?: string;
    products?: string | string[];
    categories?: string | string[];
};


type ManageThreadsListFilterProps = {
    onFiltersChange: (filters: ManageThreadsListFiltersType | undefined) => void;
};


const { spacings } = DesignTokens;


const SelectWrapper = styled.div`
max-width: 300px;
min-width: 225px;
`

export const ManageThreadsFilter: React.FC<ManageThreadsListFilterProps> = ({
    onFiltersChange
}) => {

    const [manageThreadsFilter, setManageThreadsFilter] = useState<
        ManageThreadsListFiltersType | undefined
    >(undefined);

    const [searchValue, setSearchValue] = useState("");

    useEffect(() => {
        onFiltersChange(manageThreadsFilter);
    }, [manageThreadsFilter, onFiltersChange])


    return (
        <Row gutter={[spacings.middle, spacings.middle]}>
            <Col flex={0}>
                <Search
                    onSearchInputChange={(value) => {
                        setManageThreadsFilter((prevFilter) => {
                            return { ...prevFilter, searchText: value };
                        });
                    }}
                    onChange={(e) => setSearchValue(e.target.value)}
                    value={searchValue}
                />
            </Col>
            <Col flex={0}>
                <SelectWrapper>
                    <AllProductsGeneralSelect
                        mode="multiple"
                        onChange={(value: string | string[]) => {
                            setManageThreadsFilter((prevFilter) => {
                                return {
                                    ...prevFilter,
                                    products: !isEmpty(value) ? value : undefined,
                                };
                            });
                        }}
                        value={manageThreadsFilter?.products ?? undefined}
                    />
                </SelectWrapper>
            </Col>




            {/* <Col flex={0}>
                <SelectWrapper>
                    <CategoriesSelect
                        mode="multiple"
                        onChange={(value: string | string[]) => {
                            setManageThreadsFilter((prevFilter) => {
                                return {
                                    ...prevFilter,
                                    categories: !isEmpty(value) ? value : undefined
                                }
                            })
                        }}
                        value={manageThreadsFilter?.categories ?? undefined}
                    />
                </SelectWrapper>
            </Col>
            <Col flex={0}>
                <SelectWrapper>
                    <MachinesSelect
                        mode="multiple"
                        onChange={(value: string | string[]) => {
                            setManageThreadsFilter((prevFilter) => {
                                return {
                                    ...prevFilter,
                                    machines: !isEmpty(value) ? value : undefined
                                }
                            })
                        }}
                        value={manageThreadsFilter?.machines ?? undefined}
                    />
                </SelectWrapper>
            </Col> */}
        </Row>
    )
}